import UseReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {subWeeks} from "date-fns";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters}) {
    const {
        dispatchNature,
        dispatchNatureGroups,
        streetNames,
        placeNames,
        neighborhood,
        allSectors,
    } = UseReportFiltersFetch({
        fetchDispatchNature: true,
        fetchDispatchNatureGroups: true,
        fetchStreetNames: true,
        fetchPlaceNames: true,
        fetchNeighborhood: true,
        fetchAllSectors: true,
    });

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data/hora inicial *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtStart ? new Date(filters.dtStart) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                    onBlur={(e) => {
                        if (!e.target.value?.trim()) {
                            setFilters(prev => ({ ...prev, dtStart: subWeeks(new Date(), 1) }));
                        };
                    }}
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data/hora final *"
                    classNameWrapper="w-full"
                    dateFormat="LL"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                    onBlur={(e) => {
                        if (!e.target.value?.trim()) {
                            setFilters(prev => ({ ...prev, dtEnd: new Date() }))
                        };
                    }}
                />
                <InputForm
                    id="numberCheckbox"
                    label="Talão N°"
                    classNameWrapper="w-full"
                    value={filters.numberCheckbox}
                    onChange={({ target }) => setFilters(prev => ({ ...prev, numberCheckbox: target.value }))}
                />
                <InputForm
                    id="garrison"
                    label="Guarnição"
                    classNameWrapper="w-full"
                    value={filters.garrison}
                    onChange={({ target }) => setFilters(prev => ({ ...prev, garrison: target.value}))}
                />
                <SelectComponent
                    id="nature"
                    label="Naturezas"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={dispatchNature}
                    value={filters.nature}
                    onChange={(value) => setFilters(prev => ({ ...prev, nature: value }))}
                />
                <SelectComponent
                    id="nature_groups"
                    label="Grupo de naturezas"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={dispatchNatureGroups}
                    value={filters.nature_groups}
                    onChange={(value) => setFilters(prev => ({ ...prev, nature_groups: value }))}
                />
                <SelectComponent
                    id="streetNames"
                    label="Logradouro"
                    classNameWrapper="w-full"
                    isMulti={true}
                    options={streetNames}
                    value={filters.streetNames}
                    onChange={(value) => setFilters(prev => ({ ...prev, streetNames: value }))}
                />
                <SelectComponent
                    id="placeNames"
                    label="Local pré-cadastrado"
                    classNameWrapper="w-full"
                    isMulti={true}
                    options={placeNames}
                    value={filters.placeNames}
                    onChange={(value) => setFilters(prev => ({ ...prev, placeNames: value }))}
                />
                <SelectComponent
                    id="neighborhood"
                    label="Bairro"
                    classNameWrapper="w-full"
                    isMulti={true}
                    options={neighborhood}
                    value={filters.neighborhood}
                    onChange={(value) => setFilters(prev => ({ ...prev, neighborhood: value }))}
                />
                <SelectComponent
                    id="allSectors"
                    label="Setor"
                    classNameWrapper="w-full"
                    isMulti={true}
                    options={allSectors}
                    value={filters.allSectors}
                    onChange={(value) => setFilters(prev => ({ ...prev, allSectors: value }))}
                />
            </form>
        </div>
    )
}